"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lexemes = require('./config/lexemes');
const lexer = require('./lexer');
const checker = require('./checker');
const syntaxer = require('./syntaxer');
function parseLiveQuery(options, query) {
    if (!query) {
        query = options;
        options = {};
    }
    if (query == null) { // should not be null or undefined
        throw new Error('Query string is a required parameter');
    }
    let lexemesArray = lexer.strToLexemes(query, options.spaces ? options.spaces : " \t\n");
    checker.check(lexemesArray);
    let tree = syntaxer.lexemesArrayToBinaryTree(options, lexemesArray);
    Object.keys(lexemes).forEach(function (name) {
        if (lexemes[name].postFunction) {
            tree = lexemes[name].postFunction(name, tree);
        }
    });
    if (tree === null || tree === {}) {
        throw new Error('Unable to parse query');
    }
    return tree;
}
exports.parseLiveQuery = parseLiveQuery;
